import { getToken } from "./LocalStorage";
export function authHeader() {
  // return authorization header with jwt token
  return {
    "Content-Type": "text/html;charset=utf-8",
    Accept: "text/html",
    Authorization: getToken(),
  };
}
